import { useFormMutation } from "@/hooks/useFormMutation";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { BlogPayload } from "./validation";

export const useGetBlog = (params?: string) =>
  useQuery<ApiResponse<DataPaginate<BlogResponse>>>({
    queryKey: ["useGetBlog", params],
    queryFn: () => fetcher(`article?${params}`),
  });

export const useGetBlogById = (id?: number) =>
  useQuery<ApiResponse<DataObject<BlogResponse>>>({
    queryKey: ["useGetBlogById", id],
    queryFn: () => fetcher(`article/${id}`),
    enabled: !!id,
  });

export const useBlogMutation = (id: number) => {
  return useFormMutation<ApiResponse<DataObject<any>>, Error, BlogPayload>({
    mutationFn: async (payload) => {
      return await sendData(
        id ? `article/${id}` : `article`,
        payload,
        id ? "PUT" : "POST"
      );
    },
    successMessage: `Berhasil ${id ? "Mengupdate" : "Menambah"} Data`,
  });
};
